import { render, staticRenderFns } from "./datalabelclass.vue?vue&type=template&id=e7a70a2a&scoped=true&"
import script from "./datalabelclass.vue?vue&type=script&lang=js&"
export * from "./datalabelclass.vue?vue&type=script&lang=js&"
import style0 from "./datalabelclass.vue?vue&type=style&index=0&id=e7a70a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a70a2a",
  null
  
)

export default component.exports